<template>
  <div class="mk-text" :class="{ editStatus: editStatusFlse }">
    <mk-edit-div
      v-model="tempValue"
      @textClick="childItem.contenteditable = true"
      :can-edit="childItem.contenteditable"
      @textFocus="editStatusFlse = true"
      @textBlur="
        childItem.contenteditable = false;
        editStatusFlse = false;
      "
      :style="filterCommonStyle(childItem.commonStyle)"
      :placeholder="childItem.placeholder"
    />
    <!--拖动圆点-->
    <div
      class="ui-resizable-Line"
      style="right: -4px"
      v-if="childItem.uuid === activeElementUUID"
    >
      <div
        class="ui-resizable-icon edit-shape-point"
        @mousedown="handleMouseDownOnPoint('r')"
      />
    </div>
    <div
      class="ui-resizable-Line"
      style="left: -4px"
      v-if="childItem.uuid === activeElementUUID"
    >
      <div
        class="ui-resizable-icon edit-shape-point"
        @mousedown="handleMouseDownOnPoint('l')"
      />
    </div>
  </div>
</template>

<script>
import { deepClone, getCommonStyle } from "../../../../utils/methods";
import MkEditDiv from "../../MkEditDiv/index";
import { mapState } from "vuex";
// 文本输入框
export default {
  name: "MkText",
  components: { MkEditDiv },
  computed: {
    ...mapState({
      activeElementUUID: (state) => state.autowebStore.activeElementUUID,
    }),
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      tempValue: "",
      editStatusFlse: false,
    };
  },
  created() {
    this.tempValue = this.value;
  },
  methods: {
    handleMouseDownOnPoint(point) {
      this.$emit("plTextMouseDown", point);
    },
    // 过滤组件样式
    filterCommonStyle(style, type) {
      const objD = ["position", "transform", "left", "top", "zIndex"];
      const commonModuleStyle = {};
      const cs = deepClone(getCommonStyle(style));

      objD.forEach((item) => {
        for (let i in cs) if (item === i) commonModuleStyle[item] = cs[i];
        delete cs[item];
      });
      // 如果是组件外层，就只需要objD数组里面的样式
      if (type === "commonModule") {
        return commonModuleStyle;
      } else {
        // 其他的就是组件本身的样式
        return cs;
      }
    },
  },
  watch: {
    value(val) {
      this.tempValue = val;
    },
    tempValue() {
      this.$emit("input", this.tempValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.mk-text {
  .ui-resizable-Line {
    position: absolute;
    height: 100%;
    top: 0;
    width: 9px;
  }
  .ui-resizable-icon {
    top: 50%;
    cursor: e-resize;
    margin-top: -4px;
  }
  &:before {
    content: "";
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    position: absolute;
    top: 1px;
    left: 1px;
    border: 1px solid #1ab399;
    display: none;
  }
}
.editStatus.mk-text:before {
  display: inline-block;
}
</style>
